"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckboxAlias = void 0;
var getCheckboxAlias = function (globals) {
    var colors = globals.colors;
    return {
        label: {
            color: colors.grays[700],
        },
        checkedFill: colors.primary.brand,
        checkedStroke: colors.primary.white,
        uncheckedStroke: colors.primary.black,
    };
};
exports.getCheckboxAlias = getCheckboxAlias;
